import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import FirmaRecibo from './FirmaRecibo';

function Recibos({ perfil }) {
  const [recibos, setRecibos] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState('');
  const [subiendo, setSubiendo] = useState(false);
  const [mes, setMes] = useState('');
  const [quincena, setQuincena] = useState('');
  const [archivo, setArchivo] = useState(null);
  const [userId, setUserId] = useState(null);
  const [reciboAFirmar, setReciboAFirmar] = useState(null);

  const esAdmin = perfil?.rol === 'admin' || perfil?.rol === 'rrhh';

  useEffect(() => { init(); }, []);

  async function init() {
    const { data: { user } } = await supabase.auth.getUser();
    setUserId(user.id);
    if (esAdmin) cargarEmpleados();
    else cargarRecibosDeEmpleado(user.id);
  }

  async function cargarEmpleados() {
    const { data } = await supabase.from('perfiles').select('id, nombre').order('nombre');
    setEmpleados(data || []);
  }

  async function cargarRecibosDeEmpleado(empId) {
    if (!empId) { setRecibos([]); return; }
    const { data } = await supabase
      .from('recibos')
      .select('*')
      .eq('empleado_id', empId)
      .order('created_at', { ascending: false });
    setRecibos(data || []);
  }

  function handleSeleccionEmpleado(id) {
    setEmpleadoSeleccionado(id);
    cargarRecibosDeEmpleado(id);
  }

  const getPeriodo = () => {
    if (!mes || !quincena) return '';
    return `${mes} - ${quincena}`;
  };

  async function subirRecibo() {
    const periodo = getPeriodo();
    if (!archivo || !periodo) return alert('Completá el período y seleccioná un PDF');
    if (esAdmin && !empleadoSeleccionado) return alert('Seleccioná un empleado');
    setSubiendo(true);

    const destino = esAdmin ? empleadoSeleccionado : userId;
    const nombre = `recibo_${destino}_${Date.now()}.pdf`;

    const { error: uploadError } = await supabase.storage.from('fotos').upload(nombre, archivo);
    if (uploadError) { alert('Error al subir: ' + uploadError.message); setSubiendo(false); return; }

    const { data: urlData } = supabase.storage.from('fotos').getPublicUrl(nombre);
    await supabase.from('recibos').insert([{
      empleado_id: destino,
      nombre_archivo: archivo.name,
      url: urlData.publicUrl,
      periodo
    }]);

    setMes('');
    setQuincena('');
    setArchivo(null);
    setSubiendo(false);
    cargarRecibosDeEmpleado(destino);
  }

  async function eliminarRecibo(id) {
    if (!window.confirm('¿Eliminar este recibo?')) return;
    await supabase.from('recibos').delete().eq('id', id);
    cargarRecibosDeEmpleado(empleadoSeleccionado || userId);
  }

  async function verCertificadoFirma(recibo) {
    const { data: firma } = await supabase
      .from('firmas_recibos')
      .select('*')
      .eq('recibo_id', recibo.id)
      .single();

    if (!firma) { alert('Este recibo no tiene firma registrada'); return; }

    const { data: empleado } = await supabase
      .from('perfiles')
      .select('nombre, cargo, firma_url')
      .eq('id', recibo.empleado_id)
      .single();

    const params = new URLSearchParams({
      periodo: recibo.periodo,
      empleado: empleado?.nombre || '',
      cargo: empleado?.cargo || '',
      fecha_firma: new Date(firma.fecha_firma).toLocaleString('es-AR'),
      ip: firma.ip_address || '',
      dispositivo: firma.user_agent || '',
      recibo_url: recibo.url,
      firma_img: empleado?.firma_url || '',
    });
    window.open(`/certificado-firma.html?${params.toString()}`, '_blank');
  }

  const meses = [
    'Enero 2026', 'Febrero 2026', 'Marzo 2026', 'Abril 2026',
    'Mayo 2026', 'Junio 2026', 'Julio 2026', 'Agosto 2026',
    'Septiembre 2026', 'Octubre 2026', 'Noviembre 2026', 'Diciembre 2026'
  ];

  return (
    <div className="seccion-container">
      <h2 className="seccion-titulo-pag">📄 Recibos de sueldo</h2>

      {esAdmin && (
        <div className="upload-card">
          <h3>Subir recibo</h3>
          <select value={empleadoSeleccionado} onChange={e => handleSeleccionEmpleado(e.target.value)}>
            <option value="">Seleccioná un empleado</option>
            {empleados.map(e => <option key={e.id} value={e.id}>{e.nombre}</option>)}
          </select>
          <div style={{display:'flex', gap:'8px'}}>
            <select style={{flex:1, padding:'10px', border:'1px solid #ddd', borderRadius:'6px', fontSize:'0.9rem'}} value={mes} onChange={e => setMes(e.target.value)}>
              <option value="">Mes</option>
              {meses.map(m => <option key={m} value={m}>{m}</option>)}
            </select>
            <select style={{flex:1, padding:'10px', border:'1px solid #ddd', borderRadius:'6px', fontSize:'0.9rem'}} value={quincena} onChange={e => setQuincena(e.target.value)}>
              <option value="">Período</option>
              <option value="Mensual">Mensual</option>
              <option value="1ra Quincena">1ra Quincena</option>
              <option value="2da Quincena">2da Quincena</option>
            </select>
          </div>
          <label className="btn-upload">
            {archivo ? `📄 ${archivo.name}` : '📁 Seleccionar PDF'}
            <input type="file" accept=".pdf" onChange={e => setArchivo(e.target.files[0])} hidden />
          </label>
          <button className="btn-subir" onClick={subirRecibo} disabled={subiendo}>
            {subiendo ? 'Subiendo...' : '⬆️ Subir recibo'}
          </button>
        </div>
      )}

      {esAdmin && !empleadoSeleccionado && (
        <p className="dashboard-vacio">Seleccioná un empleado para ver sus recibos.</p>
      )}

      <div className="lista-recibos">
        {recibos.length === 0 && (esAdmin ? empleadoSeleccionado : true) && (
          <p className="dashboard-vacio">
            {esAdmin ? 'Este empleado no tiene recibos.' : 'No tenés recibos cargados todavía.'}
          </p>
        )}
        {recibos.map(r => (
          <div key={r.id} className="recibo-item">
            <div className="recibo-info">
              <div style={{display:'flex', alignItems:'center', gap:8}}>
                <div className="recibo-periodo">{r.periodo}</div>
                {r.firmado
                  ? <span style={{background:'#22c55e', color:'white', fontSize:'0.72rem', padding:'2px 8px', borderRadius:20, fontWeight:700}}>✍️ Firmado</span>
                  : <span style={{background:'#f59e0b', color:'white', fontSize:'0.72rem', padding:'2px 8px', borderRadius:20, fontWeight:700}}>⏳ Sin firmar</span>
                }
              </div>
              <div className="recibo-fecha">{new Date(r.created_at).toLocaleDateString('es-AR')}</div>
              {r.firmado && r.fecha_firma && (
                <div style={{fontSize:'0.78rem', color:'#22c55e'}}>
                  Firmado el {new Date(r.fecha_firma).toLocaleDateString('es-AR')}
                </div>
              )}
            </div>
            <div className="recibo-acciones">
              <a href={r.url} target="_blank" rel="noreferrer" className="btn-ver-recibo">
                👁️ Ver
              </a>
              {!esAdmin && !r.firmado && (
                <button
                  onClick={() => setReciboAFirmar(r)}
                  style={{background:'#7c6ff7', color:'white', border:'none', padding:'6px 12px', borderRadius:6, cursor:'pointer', fontSize:'0.85rem', fontWeight:600}}
                >
                  ✍️ Firmar
                </button>
              )}
              {r.firmado && (
                <button
                  onClick={() => verCertificadoFirma(r)}
                  style={{background:'#1a1a2e', color:'white', border:'none', padding:'6px 12px', borderRadius:6, cursor:'pointer', fontSize:'0.85rem', fontWeight:600}}
                >
                  📋 Certificado
                </button>
              )}
              {esAdmin && (
                <button className="btn-eliminar-recibo" onClick={() => eliminarRecibo(r.id)}>
                  🗑️
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      {reciboAFirmar && (
        <FirmaRecibo
          recibo={reciboAFirmar}
          onCerrar={() => setReciboAFirmar(null)}
          onFirmado={() => {
            setReciboAFirmar(null);
            cargarRecibosDeEmpleado(userId);
          }}
        />
      )}
    </div>
  );
}

export default Recibos;